import { ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiStepConnector(theme: Theme): {
  MuiStepConnector: { styleOverrides: ComponentsOverrides<Theme>['MuiStepConnector'] };
} {
  return {
    MuiStepConnector: {
      styleOverrides: {
        lineVertical: {
          minHeight: '56px',
          marginLeft: '5px',
          borderLeft: '2px solid',
          borderColor: theme.palette.common.white,
        },
      },
    },
  };
}
